import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import * as generic from '../../../../components/Generico';
import { OrigenPagoBeneficiario as OrigenPagoBeneficiarioModel } from '../../../../models/ficha/OrigenPagoBeneficiario';
import { OrigenService } from '../../../../service/OrigenService';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { Pago } from '../../Pago';
import { Tercero } from '../../Tercero';

export const PagoBeneficiario = ({ toast, id, permss, catalogos, handlePrev, next, soloLectura }) => {

    const omodel = new OrigenPagoBeneficiarioModel();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const origenService = new OrigenService();
    const { inDrop, inText } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [siFormaPago, setSiFormaPago] = useState(false);
    const [siPago, setSiPago] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        origenService.consultarOrigen(id, 'seccion2').then(res => {
            const _origen = res.data.origen;

            if (!_origen) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            setSiPago(res.data.totalForma > 0);
            setSiFormaPago(_origen.tipo_entrega?.cat_id === catalogos?.beneficiario?.cat_id || _origen.tipo_entrega?.cat_id === catalogos?.tercero?.cat_id);
            reset(generic.renewValues(_origen, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion2';

        origenService.editarOrigen(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const onChangeTipoEntrega = (e) => {
        setSiFormaPago(e.value?.cat_id === catalogos?.beneficiario?.cat_id || e.value?.cat_id === catalogos?.tercero?.cat_id);
    }

    const totalTercero = (_total) => {
        setSiPago(_total > 0);
    }

    return (
        <form id="formulario-forma-pago" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('4', 'FORMA DE PAGO', 'pi pi-wallet')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('forma_pago', catalogos?.pago, { lab: omodel.optionLabel }, 12)}
                </div>
                <Pago tipo="o" id={id} permss={permss} toast={toast} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa ?? null} />
                <Divider />

                <div className="formgrid grid">
                    {inText('detalle_actividad', { icon: 'pi pi-align-left' }, 6)}
                    {inDrop('tipo_entrega', catalogos?.entregado, { lab: omodel.optionLabel, chn: onChangeTipoEntrega, ne: siPago ? 'disabled' : '' }, 6)}
                </div>
            </Panel>

            {siFormaPago &&
                <Panel header={generic.renderPanelHeader('5', 'BENEFICIARIO FINAL / TERCEROS', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                    <Message severity="info" text="En caso de señalar Beneficiario Final o Tercero/s complete lo siguiente:" style={{ width: '100%' }} className="mb-3" />
                    <Tercero tipo="o" id={id} permss={permss} toast={toast} lista={catalogos} soloLectura={soloLectura} totalTercero={totalTercero} />
                </Panel>
            }

            <BottomActionBar formId="formulario-forma-pago" onPrev={handlePrev} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
